/* ///////////////////////////////////////////////////// */
// Canvas aspect ratio = 1/1,
/* ///////////////////////////////////////////////////// */

jQuery(function ($) {
  if ($('#spider-chart-canvas').length === 0) { return; }

  // console.log('spider-chart.js');

  const baseUrl = $('#base-url').data('base-url');

  // Chart labels
  const labels = [
    'Credible Elections',
    'Inclusive Suffrage',
    'Free Political Parties',
    'Elected Government',
    'Effective Parliament',
    'Local Democracy',

    'Access to Justice',
    'Civil Liberties',
    'Basic Welfare',
    'Political Equality',

    'Judicial Independence',
    'Absence of Corruption',
    'Predictable Enforcement',
    'Personal integrity & Security',

    'Electoral Participation',
    'Civic Engagement',
    'Civil Society',
  ];

  // let data1 = [];

  // for (i=0; i<15; i++) {
  //   data1[i] = Math.floor((Math.random() * 60) + 20) / 100;
  // }

  // let data2 = [];

  // for (i=0; i<15; i++) {
  //   data2[i] = Math.floor((Math.random() * 60) + 20) / 100;
  // }

  // let data3 = [];

  // for (i=0; i<15; i++) {
  //   data3[i] = Math.floor((Math.random() * 60) + 20) / 100;
  // }

  // const dataset = [data1, data2, data3];
  // Dummy data end ////////////////////////////////////////////

  let canvas = document.getElementById("spider-chart-canvas");

  // Canvas width set to 2.01 to avoid clipping when set to 2
  canvas.width = canvas.getBoundingClientRect().width * 2.01;
  canvas.height = canvas.width; // Make a square canvas

  const cvWidth = canvas.width;
  const cvHeight = canvas.height;
  const webLength = cvWidth / 2 * 0.5; // Half of web diameter
  const totalLabels = labels.length;
  const centerX = cvWidth / 2;
  const centerY = cvHeight / 2;
  const startingAngle = -90; // Start drawing at 12 o'clock

  let ctx = canvas.getContext("2d");
  ctx.strokeStyle = "#ffffff55";
  ctx.lineWidth = 1.5;

  function drawSpiderChart(data) {
    ctx.clearRect(0, 0, cvWidth, cvHeight);
    drawWeb();
    drawLoop(webLength);
    drawLoop(webLength * 0.5);
    drawLoop(webLength * 0.5 * 0.5);
    drawLoop(webLength * 0.5 * 0.5 * 0.5);
    drawText(data);
    drawData(data);
  }

  function drawWeb() {
    // Drawing radiant lines
    for (i = 0; i < totalLabels; i++) {
      ctx.beginPath();
      ctx.moveTo(cvWidth / 2, cvWidth / 2);

      let angle = startingAngle + i * 360 / totalLabels;

      let toX = centerX + Math.cos(Math.PI * angle / 180) * webLength;
      let toY = centerY + Math.sin(Math.PI * angle / 180) * webLength;

      ctx.lineTo(toX, toY);
      ctx.stroke();
    }
  }
  // drawWeb end //////////////////////////////////////////////////

  function drawLoop(length) {
    let startX = centerX + Math.cos(Math.PI * startingAngle / 180) * length;
    let startY = centerY + Math.sin(Math.PI * startingAngle / 180) * length;

    ctx.beginPath();
    ctx.moveTo(startX, startY);

    // Drawing outer loop
    for (i = 1; i < totalLabels; i++) {
      let angle = startingAngle + i * 360 / totalLabels;
      let toX = centerX + Math.cos(Math.PI * angle / 180) * length;
      let toY = centerY + Math.sin(Math.PI * angle / 180) * length;

      ctx.lineTo(toX, toY);
    }

    ctx.closePath();
    ctx.stroke();
  }
  // drawLoop end /////////////////////////////////////////////////

  function drawText(data) {
    for (i = 0; i < totalLabels; i++) {
      let x;
      let y;
      let txt = labels[i].toUpperCase();

      ctx.save();
      ctx.font = "20px aileron";
      ctx.textAlign = "left";
      ctx.textBaseline = "middle";
      ctx.fillStyle = "#FFFFFFBB";

      let txtWidth = ctx.measureText(txt).width;
      let angle = startingAngle + i * 360 / totalLabels;

      if (angle > 90) {
        x = centerX + Math.cos(Math.PI * angle / 180) * (webLength + 25 + txtWidth);
        y = centerY + Math.sin(Math.PI * angle / 180) * (webLength + 25 + txtWidth);
      } else {
        x = centerX + Math.cos(Math.PI * angle / 180) * (webLength + 25);
        y = centerY + Math.sin(Math.PI * angle / 180) * (webLength + 25);
      }

      ctx.translate(x, y);

      if (angle > 90) {
        ctx.transform(-1, 0, 0, -1, 0, 0);
      }

      ctx.rotate(Math.PI / 180 * angle, 255, 255);
      ctx.fillText(txt, 0, 0);
      ctx.restore();
    }

    for (i = 0; i < totalLabels; i++) {
      let x;
      let y;
      let txt = data[i];

      ctx.save();
      ctx.font = "bold 20px aileron";
      ctx.textAlign = "left";
      ctx.textBaseline = "middle";
      ctx.fillStyle = "#FFFFFF";

      let labelWidth = ctx.measureText(labels[i].toUpperCase()).width;
      let txtWidth = ctx.measureText(txt).width;
      let angle = startingAngle + i * 360 / totalLabels;

      if (angle > 90) {
        x = centerX + Math.cos(Math.PI * angle / 180) * (webLength + 25 + labelWidth + txtWidth);
        y = centerY + Math.sin(Math.PI * angle / 180) * (webLength + 25 + labelWidth + txtWidth);
      } else {
        x = centerX + Math.cos(Math.PI * angle / 180) * (webLength + 25 + labelWidth);
        y = centerY + Math.sin(Math.PI * angle / 180) * (webLength + 25 + labelWidth);
      }

      ctx.translate(x, y);

      if (angle > 90) {
        ctx.transform(-1, 0, 0, -1, 0, 0);
      }

      ctx.rotate(Math.PI / 180 * angle, 255, 255);
      ctx.fillText(txt, 0, 0);
      ctx.restore();
    }
  }
  // drawText end /////////////////////////////////////////////////

  function drawData(data) {
    const totalData = data.length;

    let startX = centerX + Math.cos(Math.PI * startingAngle / 180) * (webLength * data[0]);
    let startY = centerY + Math.sin(Math.PI * startingAngle / 180) * (webLength * data[0]);

    ctx.save();
    ctx.beginPath();
    ctx.moveTo(startX, startY);

    // Drawing data loop
    for (i = 1; i < totalLabels; i++) {
      let angle = startingAngle + i * 360 / totalLabels;
      let toX = centerX + Math.cos(Math.PI * angle / 180) * (webLength * data[i]);
      let toY = centerY + Math.sin(Math.PI * angle / 180) * (webLength * data[i]);

      ctx.lineTo(toX, toY);
    }

    ctx.closePath();

    ctx.strokeStyle = "#2260DA";
    ctx.lineWidth = 3;
    ctx.stroke();

    let grd = ctx.createLinearGradient(cvWidth / 2, cvHeight * 0.33, cvWidth / 2, cvHeight * 0.66);
    grd.addColorStop(0, "#2260DA55");
    grd.addColorStop(1, "#2260DA00");
    ctx.fillStyle = grd;
    ctx.fill();

    ctx.restore();
  }
  // drawData end /////////////////////////////////////////////////

  let activeDataIndex = 0;
  let animateFromDataIndex;
  let animateToDataIndex;
  let animFrame = 1;
  let myReq;
  const duration = 30;

  function animateChart() {
    animFrame++;

    if (animFrame > duration) {
      cancelAnimationFrame(myReq);
    } else {
      let data = [];

      for (i = 0; i <= (totalLabels - 1); i++) {
        data.push(+
          (
            dataset[animateFromDataIndex][i] +
            (
              (dataset[animateToDataIndex][i] - dataset[animateFromDataIndex][i])
              // * (animFrame / duration)
              * Math.sin((animFrame / duration * 90) * Math.PI / 180)
            )
          ).toFixed(2));
      }

      drawSpiderChart(data);

      myReq = requestAnimationFrame(animateChart);
    }
  }

  // $('.switch-data').on('click', function(){
  //   const index = $(this).data('index');

  //   if (index === activeDataIndex) {
  //     return;
  //   }

  //   animateFromDataIndex = activeDataIndex;
  //   animateToDataIndex = index;
  //   activeDataIndex = index;

  //   animFrame = 1;
  //   myReq = requestAnimationFrame(animateChart);
  // });

  const rangeControl = $('#range-spider-chart-years');
  const cid = $('#country-data').data('cid');
  let apiData; // API returned data
  let dataset; // data of current active year

  const settings = {
    "url": baseUrl + "api/gsod-indices-data?cid=" + cid,
    "method": "GET",
    "timeout": 0,
    "headers": {
      "Content-Type": "application/json"
    },
    error: function (error) {
      console.log('error', error);
    }
  };

  function getRegimeTypeColor(type) {
    switch (type) {
      case "Democratic":
        return "#48CE96";
        break;

      case "Hybrid":
        return "#7D8A98";
        break;

      case "Authoritarian":
        return "#F56363";
        break;

      case "Autocratic":
        return "#F56363";
        break;

      default:
        return "#ffffff";
        break;
    }
  }

  // console.log('url', settings.url);

  $.ajax(settings).done(function (response) {
    // console.log('API response: ', response);

    apiData = response;
    const data = apiData;

    // Set year slider min, max and default value
    rangeControl.attr('min', 0);
    rangeControl.attr('max', data.length - 1);
    rangeControl.val(data.length - 1);
    // Init year slider tooltip
    rangeTooltip(data[data.length - 1].year, data[data.length - 1].regime_type);


    $('#range-label-min').text(data[0].year);
    $('#range-label-max').text(data[data.length - 1].year);

    // Generate background color for Years range input
    let currtype = data[0].regime_type;
    let bgStyle = "linear-gradient(90deg, " + getRegimeTypeColor(data[0].regime_type) + " 0%, ";

    for (var i = 1; i < data.length; i++) {
      if (data[i].regime_type !== currtype) {
        let a = Math.round((i / data.length * 100) * 100) / 100;
        let b = a + 0.01;

        bgStyle += getRegimeTypeColor(currtype) + " " + a + "%, ";
        bgStyle += getRegimeTypeColor(data[i].regime_type) + " " + b + "%, ";
        currtype = data[i].regime_type;
      }
    }

    bgStyle += getRegimeTypeColor(data[data.length - 1].regime_type) + " 100%)";

    rangeControl.css('background', bgStyle);

    rangeControl.on('input', function () {
      const v = $(this).val();

      // console.log('v', data[v].year, data[v].regime_type);
    });

    rangeControl.on('change', function () {
      const index = $(this).val();

      // console.log('index', index, data[index].year, data[index].data);
      // console.log('index', index, data[index].year, data[index].regime_type);

      rangeTooltip(data[index].year, data[index].regime_type);

      animateToDataIndex = index;

      if (index === activeDataIndex) {
        return;
      }

      animateFromDataIndex = activeDataIndex;
      animateToDataIndex = index;
      activeDataIndex = index;

      // console.log('dataset', dataset[animateToDataIndex]);

      animFrame = 1;
      myReq = requestAnimationFrame(animateChart);

      drawLineChart(dataset[index]);
    });
    // rangeControl on change end

    dataset = data.map((year, i) => {
      const indices = year.data.map((v, i) => {
        return v.value;
      });

      return indices;
    });

    // console.log(dataset);
    // console.log(data);

    // console.log('dataset', dataset);

    drawSpiderChart(dataset[dataset.length - 1]);
    drawLineChart(dataset[dataset.length - 1]);
    activeDataIndex = dataset.length - 1;

    $('#spider-chart-loading-blocker').fadeOut(1000, function () {
      $('.scc-tooltip').fadeIn(500);
      $(this).remove();
    });
  });

  // Regime type line chart for mobile view
  function drawLineChart(data) {
    $.each(data, function (index, value) {
      $('#regime-type-line-chart .indice-title.n' + index).html(labels[index] + ' ' + value);
      $('#regime-type-line-chart .data-bar.n' + index).css('width', (value * 100) + '%');
    });
  }

  function rangeTooltip(year, label) {
    const rW = rangeControl.width();
    const index = rangeControl.val(); // Current value/position of slider thumb
    const min = rangeControl.attr('min');
    const max = rangeControl.attr('max');
    // const pos = ((index - min) / max * 100);
    const pos = ((index - min) / max * rW) + ((index - (max / 2)) / max * -1 * 18); // 18 is width of slider thumb

    // console.log('ref', (index - (max / 2)) / max * -1 * 18);
    // console.log('index', index);
    // console.log('pos', pos);

    $('.scc-tooltip .year').html(year);
    $('.scc-tooltip .label').html(label);
    $('.scc-tooltip').css('left', pos + 'px');
  }

  $(window).on('resize', function () {
    rangeTooltip(apiData[activeDataIndex].year, apiData[activeDataIndex].label);
  });
});
